import { thoughtspot } from 'config';
import moneyIcon from 'assets/icons/money.svg';
import chartLineIcon from 'assets/icons/chart_line.svg';
import { isThoughtspotEnabled } from 'utils/thoughtspotInit';
import LiveDealsMetrics from './LiveDealsMetrics';
import PendingCreativesMetrics from './PendingCreativesMetrics';
import LiveboardVisualMetric from './LiveboardVisualMetric';

const metricCardClassName = 'w-full flex-1 min-w-[200px] basis-[200px]';

const Metrics: React.FC = () => {
  return (
    <div className="flex flex-col gap-2 mb-4">
      {isThoughtspotEnabled && (
        <div className="body-sm italic text-neutral-700" data-test-id="metrics-timestamp">
          Data is refreshed every 45 mins, in line with Deal Health
        </div>
      )}
      <div className="flex flex-wrap gap-4 w-full">
        {isThoughtspotEnabled && (
          <>
            <div className={metricCardClassName}>
              <LiveboardVisualMetric vizId={thoughtspot.todaysRevenueVizId} icon={moneyIcon} name="Today's revenue" />
            </div>
            <div className={metricCardClassName}>
              <LiveboardVisualMetric
                vizId={thoughtspot.monthToDateVizId}
                icon={chartLineIcon}
                name="Month-to-date (MTD) revenue"
              />
            </div>
          </>
        )}
        <div className={metricCardClassName}>
          <LiveDealsMetrics />
        </div>
        <div className={metricCardClassName}>
          <PendingCreativesMetrics />
        </div>
      </div>
    </div>
  );
};

export default Metrics;
